/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountBatchResponse {
    getFixupPrototypeFunction() { return ServiceAccountBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountBatchResponse>): ServiceAccountBatchResponse {
        let obj = Object.assign(new ServiceAccountBatchResponse(), model);
        ServiceAccountBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountBatchResponse>): ServiceAccountBatchResponse {
        if (!model) return null;
        return ServiceAccountBatchResponse.newInstance(<ServiceAccountBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountBatchResponse) {
        if (!obj) return;

        models.ServiceAccountBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountBatchResponse): boolean {
        Object.setPrototypeOf(obj, ServiceAccountBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.ServiceAccountDetailsWithAdditionalInfo.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.ServiceAccountDetailsWithAdditionalInfo; };

}
